import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'departments'
const initialState = {
  list: null,
}

export const search = createApiAction('department/search', client.search('/api/hr/department'))
export const get = createApiAction('department/get', client.retrieve(`/api/hr/department/:id`))
export const save = createApiAction('department/save', client.save('/api/hr/department'))
export const destroy = createApiAction('department/delete', client.destroy('/api/hr/department/:id'))

const update = (state, action) => {
  const found = state.list?.find(rec => rec.id === action.payload.id)
  if (state.list) {
    state.list = found
      ? state.list?.map(item => (found.id === item.id ? action.payload : item))
      : [...state.list, action.payload]
  }
}

const sessionSlice = createSlice({
  name,
  initialState,
  extraReducers(builder) {
    builder
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload
      })
      .addCase(get.fulfilled, update)
      .addCase(save.fulfilled, update)
      .addCase(destroy.fulfilled, (state, action) => {
        state.list = state.list.filter(item => item.id !== action.payload.id)
      })
  },
})
export default sessionSlice.reducer
